import React from "react";
import Pagination from '../../common/pagination'
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";

class Revenve extends React.Component {
    constructor(props) {

        super(props)
        this.state = {
            pageOfItemsZero: [],

        };
    }
    onChangeZero = (pageOfItems) => {
        this.setState({ pageOfItemsZero: pageOfItems });
    }


    render() {
        let {
            pageOfItemsZero,
        } = this.state

        let revenueReportList = [];

        if (this.props.getRevenueReportStatus) {

            revenueReportList = this.props.getRevenueReportList.faxResponseList

        }

        if (this.props.export) {
            pageOfItemsZero = revenueReportList
        }

        return (
            <React.Fragment>
                {this.props.getRevenueReportStatus ?
                    <>
                        <table id="table-to-xls" className="table commonTable">
                            <thead>
                                <tr>
                                    <th>Request Id</th>
                                    <th>Employee Name</th>
                                    <th>Practice Name</th>
                                    <th>Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pageOfItemsZero.length > 0 ?
                                    pageOfItemsZero.map((req, id) => {
                                        return (
                                            <tr key={id}>
                                                <td>{req.id} </td>
                                                <td>{req.employeeName} </td>
                                                <td>{req.facilityName} </td>
                                                <td>{req.finalCost} </td>
                                            </tr>
                                        )
                                    }) : <tr className="icon-page-not-found" style={{ background: "transparent" }}><td colspan="6"><img alt="" src="images/search-page.png" width="200px" style={{ opacity: "0.8" }} /></td></tr>

                                }
                            </tbody>

                        </table>

                        <Pagination items={revenueReportList} onChangePage={this.onChangeZero} />
                    </> : <tr className="icon-page-not-found" style={{ background: "transparent" }}><td colspan="6"><img alt="" src="images/search-page.png" width="200px" style={{ opacity: "0.8" }} /></td></tr>

                }
            </React.Fragment>
        )
    }
}
const mapStateToProps = state => ({
    getRevenueReportStatus: state.adminReducer.getRevenueReportStatus,
    getRevenueReportList: state.adminReducer.getRevenueReportList,

});

export default connect(
    mapStateToProps,
    null
)(Revenve);


